export default __webpack_public_path__ + "static/media/learning.38d9b8ca.svg";